/* b2s-article-buybox.js — in-article buy box (Snorekit default + size/subscription) with ATC.
   Self-contained: dynamic pricing from product JSON, localized labels, adds to the native cart drawer.
   DRAFT THEME ONLY. */
(function () {
  'use strict';
  var SNOREKIT = 41431169499319;
  var SIZE = { S: 41431140794551, M: 41431140827319, L: 41431140860087, XL: 41431140892855 };
  var PLAN = { monthly: 694337306971, yearly: 694337339739 };
  var SIZE_HANDLE = 'nasal-stent-back2sleep';
  var SNORE_HANDLE = 'back2sleep-starter-kit';

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) { return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* i18n from locale keys injected by Liquid (window.B2S_I18N.buybox) — plugin translates; English fallback = source */
  var T = (window.B2S_I18N && window.B2S_I18N.buybox) || {"eyebrow":"Start sleeping better tonight","heading":"Snorekit anti-snoring","snorekit_name":"Snorekit","snorekit_sub":"Contains all 4 sizes — ideal for a first try","size_name":"I already know my size","size_sub":"Single-size refill","pick_size":"Select your size","pick_plan":"Choose your plan","onetime":"One-time purchase","onetime_sub":"Single delivery","monthly":"Monthly subscription","monthly_sub":"Free shipping · cancel anytime","yearly":"Annual plan","yearly_sub":"Best price per box · billed yearly","free_shipping":"Free shipping","save":"Save","tax":"Tax included","ship":"Shipping cost will be added at checkout","fee":"France: €5","atc":"Add to cart","adding":"Adding…","added":"Added ✓","trust":"Free delivery in continental EU · Secure checkout","pick_first":"Please select a size first."};

  /* ---------- state + pricing ---------- */
  var PRICING = null;      // { S:{onetime,monthly,yearly}, ... }
  var SNOREKIT_PRICE = null;
  var PLAN_QTY = { onetime: 1, monthly: 1, yearly: 1 }; // synced from Recharge "Product Quantity" (annual = 12 boxes, billed once a year)
  var state = { mode: 'snorekit', size: null, plan: 'onetime' };

  function loadPricing() {
    var p1 = fetch('/products/' + SIZE_HANDLE + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
      var map = {};
      (p.variants || []).forEach(function (v) {
        var s = (v.option1 || v.title || '').trim().toUpperCase();
        if (!SIZE[s]) return;
        var e = { onetime: v.price, monthly: null, yearly: null };
        (v.selling_plan_allocations || []).forEach(function (a) {
          var perBox = (a.per_delivery_price != null ? a.per_delivery_price : a.price);
          if (Number(a.selling_plan_id) === PLAN.monthly) e.monthly = perBox;
          if (Number(a.selling_plan_id) === PLAN.yearly) e.yearly = perBox;
        });
        map[s] = e;
      });
      PRICING = map;
      // sync billed quantity per plan from Recharge ("12 products every 12 months" -> 12)
      (p.selling_plan_groups || []).forEach(function (g) {
        (g.selling_plans || []).forEach(function (s) {
          var q = 1; (s.options || []).forEach(function (o) { if (/quantity/i.test(o.name)) { var n = parseInt(o.value, 10); if (n > 0) q = n; } });
          if (Number(s.id) === PLAN.monthly) PLAN_QTY.monthly = q;
          if (Number(s.id) === PLAN.yearly) PLAN_QTY.yearly = q;
        });
      });
    }).catch(function () {});
    var p2 = fetch('/products/' + SNORE_HANDLE + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) { SNOREKIT_PRICE = p.price; }).catch(function () {});
    return Promise.all([p1, p2]);
  }

  function sizePrice(sz, plan) { if (!PRICING || !PRICING[sz]) return null; return PRICING[sz][plan]; }

  function currentVariant() {
    if (state.mode === 'snorekit') return { id: SNOREKIT, quantity: 1 };
    if (!state.size) return { error: 'size' };
    var sel = { id: SIZE[state.size], quantity: (PLAN_QTY[state.plan] || 1) };
    if (state.plan !== 'onetime' && PLAN[state.plan]) sel.selling_plan = PLAN[state.plan];
    return sel;
  }
  function currentPrice() {
    if (state.mode === 'snorekit') return SNOREKIT_PRICE;
    var sz = state.size || 'M';
    var per = sizePrice(sz, state.plan);
    return per == null ? null : per * (PLAN_QTY[state.plan] || 1);
  }

  /* ---------- render ---------- */
  var root;
  function applyI18n() {
    $all('[data-i18n]', root).forEach(function (el) { var k = el.getAttribute('data-i18n'); if (T[k] != null) el.textContent = T[k]; });
  }
  function renderPrice() {
    var amt = $('.b2s-bb__price-amt', root);
    var pr = currentPrice();
    if (amt && pr != null) amt.textContent = money(pr);
  }
  function renderPlanPrices() {
    var sz = state.size || 'M';
    var base = sizePrice(sz, 'onetime');
    $all('.b2s-bb__plan', root).forEach(function (opt) {
      var key = opt.dataset.plan;
      var pr = sizePrice(sz, key);            // per box
      var qty = PLAN_QTY[key] || 1;
      var unavailable = key !== 'onetime' && !!PRICING && pr == null;
      opt.hidden = unavailable;
      var pe = $('.b2s-bb__plan-price', opt);
      if (pe) pe.textContent = pr != null ? money(pr * qty) : (key === 'onetime' ? money(base || 3400) : '');
      // multi-box plan (annual): spell out "perbox × N" in the subtitle so the yearly total is clear
      var subEl = $('.b2s-bb__plan-sub', opt);
      if (subEl) subEl.textContent = (qty > 1 && pr != null) ? (money(pr) + ' × ' + qty + ' · ' + (T[key + '_sub'] || '')) : (T[key + '_sub'] || subEl.textContent);
      var badge = $('.b2s-bb__plan-badge', opt);
      if (badge) {
        if (key === 'monthly') { badge.hidden = false; badge.textContent = T.free_shipping; }
        else if (key === 'yearly' && pr != null && base != null && pr < base) { badge.hidden = false; badge.textContent = T.save + ' ' + Math.round((1 - pr / base) * 100) + '%'; }
        else { badge.hidden = true; }
      }
    });
  }
  function syncActive() {
    $all('.b2s-bb__mode', root).forEach(function (m) { m.classList.toggle('is-active', m.dataset.mode === state.mode); });
    var sizes = $('.b2s-bb__sizes', root); if (sizes) sizes.hidden = state.mode !== 'size';
    $all('.b2s-bb__size', root).forEach(function (s) { s.classList.toggle('is-active', s.dataset.size === state.size); });
    $all('.b2s-bb__plan', root).forEach(function (p) { p.classList.toggle('is-active', p.dataset.plan === state.plan); });
    renderPrice();
  }

  function openDrawer(resp) {
    var cart = document.querySelector('cart-drawer');
    if (cart) {
      // The theme's CSS `cart-drawer.is-empty .drawer__inner{display:grid;align-items:center}` collapses
      // the items into a centered empty-state grid while the drawer element keeps is-empty (set when the
      // cart was empty on page load). renderContents only clears it on .drawer__inner, not the element —
      // so we strip it here (before + after render), exactly like the native product-form does.
      cart.classList.remove('is-empty');
      if (cart.renderContents && resp && resp.sections) {
        try { cart.renderContents(resp); setTimeout(function () { cart.classList.remove('is-empty'); }, 60); return; } catch (e) {}
      }
      var path = window.location.pathname.replace(/\/$/, '') || '';
      fetch(path + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (sec) { try { cart.renderContents({ sections: sec }); } catch (e) { if (cart.open) cart.open(); } })
        .catch(function () { if (cart.classList) cart.classList.add('active', 'animate'); });
      return;
    }
    window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
  }

  var adding = false;
  function add() {
    if (adding) return;
    var sel = currentVariant();
    if (sel.error === 'size') { var hint = $('.b2s-bb__hint', root); if (hint) { hint.textContent = T.pick_first; hint.classList.add('show'); } var sz = $('.b2s-bb__sizes', root); if (sz) sz.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    var hint = $('.b2s-bb__hint', root); if (hint) hint.classList.remove('show');
    adding = true;
    var btn = $('.b2s-bb__atc', root); var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = T.adding; }
    var cart = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', sel.id); fd.append('quantity', sel.quantity || 1);
    if (sel.selling_plan) fd.append('selling_plan', sel.selling_plan);
    if (cart && cart.getSectionsToRender) { try { fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); } catch (e) {} }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp && resp.status) { if (btn) btn.textContent = label; return; }
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: resp })); } catch (e) {}
        try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'b2s-article-buybox', cartData: resp }); } catch (e) {}
        if (btn) btn.textContent = T.added;
        openDrawer(resp);
        setTimeout(function () { if (btn) btn.textContent = label; }, 1800);
      })
      .catch(function () { if (btn) btn.textContent = label; })
      .finally(function () { setTimeout(function () { adding = false; if (btn) btn.disabled = false; }, 700); });
  }

  function bind() {
    root.addEventListener('click', function (e) {
      var mode = e.target.closest('.b2s-bb__mode'); if (mode) { state.mode = mode.dataset.mode; if (state.mode === 'size' && !state.size) state.size = 'M'; syncActive(); renderPlanPrices(); return; }
      var size = e.target.closest('.b2s-bb__size'); if (size) { state.size = size.dataset.size; syncActive(); renderPlanPrices(); return; }
      var plan = e.target.closest('.b2s-bb__plan'); if (plan && !plan.hidden) { state.plan = plan.dataset.plan; syncActive(); return; }
      var atc = e.target.closest('.b2s-bb__atc'); if (atc) { e.preventDefault(); add(); return; }
    });
  }

  function init() {
    root = document.getElementById('b2s-article-buybox');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    applyI18n();
    bind();
    syncActive();
    loadPricing().then(function () { renderPrice(); renderPlanPrices(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
